import { useState } from "react";
import { Search, ChevronDown, MessageCircle, Mail, Phone } from "lucide-react";

const HelpPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [openFaq, setOpenFaq] = useState<string | null>(null);

  const faqs = [
    {
      id: "1",
      question: "How do I create an account?",
      answer:
        'Click on the "Register" button, fill in your details, verify your email and phone number, and you\'re ready to start trading.',
    },
    {
      id: "2",
      question: "What is KYC verification?",
      answer:
        "KYC (Know Your Customer) verification is a process where we verify your identity to comply with regulations and ensure platform security. You'll need to provide a valid ID and proof of address.",
    },
    {
      id: "3",
      question: "How do I deposit funds?",
      answer:
        'Go to your Wallet, click "Deposit", select your preferred cryptocurrency or fiat method, and follow the instructions. For crypto deposits, send funds to the provided wallet address.',
    },
    {
      id: "4",
      question: "What are the trading fees?",
      answer:
        "Spot trading fees are 0.1% for makers and 0.1% for takers. P2P trading is free for buyers, sellers pay 0.5% fee.",
    },
    {
      id: "5",
      question: "How do I withdraw funds?",
      answer:
        'Go to your Wallet, click "Withdraw", select the asset, enter the amount and destination address, confirm the transaction, and complete any required security verification.',
    },
    {
      id: "6",
      question: "Is my money safe on BUYFIAT?",
      answer:
        "Yes, we use industry-leading security measures including cold storage for crypto assets, two-factor authentication, encryption, and regular security audits.",
    },
  ];

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div className="min-h-screen bg-background pt-24 px-4 lg:px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-foreground mb-6">Help Center</h1>

        {/* Search */}
        <div className="relative mb-8">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search for help..."
            className="w-full pl-12 pr-4 py-4 bg-card border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary transition-colors"
          />
        </div>

        {/* FAQs */}
        <div className="nex-card p-6 mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <div className="space-y-2">
            {filteredFaqs.map((faq) => (
              <div
                key={faq.id}
                className="border-b border-border last:border-0"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
                  className="w-full flex items-center justify-between py-4 text-left"
                >
                  <span className="text-foreground font-medium">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-muted-foreground transition-transform ${
                      openFaq === faq.id ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openFaq === faq.id && (
                  <p className="pb-4 text-muted-foreground">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="grid md:grid-cols-3 gap-4">
          <div className="nex-card p-6 text-center">
            <MessageCircle className="w-8 h-8 text-primary mx-auto mb-3" />
            <h3 className="font-semibold text-foreground mb-1">Live Chat</h3>
            <p className="text-sm text-muted-foreground mb-3">Available 24/7</p>
            <button className="px-4 py-2 bg-[#F0B90B] text-black text-sm font-medium rounded-lg hover:brightness-110 transition-all">
              Start Chat
            </button>
          </div>
          <div className="nex-card p-6 text-center">
            <Mail className="w-8 h-8 text-primary mx-auto mb-3" />
            <h3 className="font-semibold text-foreground mb-1">
              Email Support
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              support@buyfiat.app
            </p>
            <button className="px-4 py-2 bg-muted text-foreground text-sm font-medium rounded-lg hover:bg-[#343A42] transition-colors">
              Send Email
            </button>
          </div>
          <div className="nex-card p-6 text-center">
            <Phone className="w-8 h-8 text-primary mx-auto mb-3" />
            <h3 className="font-semibold text-foreground mb-1">
              Phone Support
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              +234 800 BUYFIAT
            </p>
            <button className="px-4 py-2 bg-muted text-foreground text-sm font-medium rounded-lg hover:bg-[#343A42] transition-colors">
              Call Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
